import { Controller } from "@hotwired/stimulus";

// Updates an admin context link's href to include the current URL as a search query parameter.
// Updates the href when the parent popup opens (via toggle event on <details> element),
// ensuring the link always reflects the current page URL at the moment of interaction.
//
// Connects with data-controller="admin-context-link"
export default class extends Controller<HTMLAnchorElement> {
  static values = {
    basePath: String,
  };

  declare basePathValue: string;

  private detailsElement: HTMLDetailsElement | null = null;
  private boundUpdateHref: (() => void) | null = null;

  connect() {
    this.boundUpdateHref = this.updateHref.bind(this);
    this.updateHref();

    // Find the parent <details> element (popup container) and listen for toggle
    this.detailsElement = this.element.closest("details");
    this.detailsElement?.addEventListener("toggle", this.boundUpdateHref);
  }

  disconnect() {
    if (this.boundUpdateHref) {
      this.detailsElement?.removeEventListener("toggle", this.boundUpdateHref);
    }
  }

  private updateHref() {
    const url = new URL(this.basePathValue, window.location.origin);
    url.searchParams.set("context", "true");
    url.searchParams.set("search[query]", window.location.href);
    this.element.href = url.toString();
  }
}
